import React, { Component, createRef } from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import Cookies from "universal-cookie";
import formatCurrencytoBr from 'format-currency-to-br';
import TagManager from 'react-gtm-module';
import md5 from 'md5';

import Tabs from '../childrens/tabs/.mixins';
import Filter from '../childrens/filter/.mixins';
import ConfirmCheckbox from '../childrens/confirmCheckbox/.mixins';
import CheckAllCheckbox from '../childrens/checkAllCheckbox/.mixins';
import Loader from '../childrens/loader/.mixins';
import Progress from '../childrens/progress/.mixins';

import { ColTodosPedidos } from "../childrens/tabs/childrens/todosPedidos/childrens/tabela/childrens/columns/.mixins";

import Cabecario from '../../../../../util/cabecario/.mixins';
import Alerta from '../../../../../util/snackbars/.mixins';

import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';
import Pessoas_controller from '../../../../../../controllers/pessoa';

import GerenciarPedidos_controller from '../../../../../../controllers/gerenciarPedidos';
import OpcoesRecebimentoController from '../../../../../../controllers/opcoesRecebimento';
import { getPedidosAgendados } from '../../../../../../controllers/agendamentosRespondidos';

import { Can } from '../../../../../util/Can';
import { AuthContext } from '../../../../../../contexts/AuthContext';

class GerenciarPedidos extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.childAlerta = createRef();
    this.permissions = {};
    this.isVisaoTok = false;

    this.state = {

      // Atributos do filtro fornecedor
      fornecedores: [],
      fornecedor: 0,
      fornecedorName: "",

      // Atributos Tab
      valueTab: 0,
      progressPercentZip: 0,
      progressPercentZipBoolean: false,

      // Tabela Todos pedidos
      dataTodosPedidos: [],
      dataTodosPedidosSelected: [],
      dataTodosPedidosSelectedEtiquetas: [],
      tipoEtiquetaDownload: "",
      dataTodosPedidosIndexSelected: [],
      columnsTodosPedidos: [],
      gruposColunasTodosPedidos: [
        {
          id: 1,
          label: "Data",
        },
        {
          id: 2,
          label: "Entrega",
        },
        {
          id: 3,
          label: "Valores",
        },
        {
          id: 4,
          label: "Pedido / Produto",
        },
        {
          id: 5,
          label: "Outros",
        },
      ],

      firstLoad: false,
      qtdTodosPedidos: 0,
      pageInitialTodosPedidos: 0,
      pageRowsTodosPedidos: 5,
      rowsPerPageOptionsTodosPedidos: [5, 10, 25, 50, 100],
      checkPermissionOpcoesRecebimento: false,

      // Tabela Agendamento pendentes
      dataAgendamentoPendentes: [],
      dataAgendamentoPendentesSelected: [],
      qtdAgendamentoPendentes: 0,

      // Paginacao agendamento pendente
      pageInitialAgendamentoPendentes: 0,
      pageRowsAgendamentoPendentes: 5,

      /* Atributos da modal de filtro - Begin */
      searchFieldTodosPedidos: "",
      searchFieldExternalTodosPedidos: "",
      searchFieldAgendamentoPendentes: "",

      escolhaDataTodosPedidos: "dtEmissao",

      dtInitialTodosPedidos: moment().toDate(),
      dtEndTodosPedidos: moment().add(30, 'days').toDate(),

      dtInitialAgendamentoPendentes: moment().toDate(),
      dtEndAgendamentoPendentes: moment().add(30, 'days').toDate(),

      escolhaFilialTodosPedidos: { id: 0, name: "Selecione uma filial" },
      escolhaCondicaoTodosPedidos: { id: 0, name: "Selecione uma condição" },
      escolhaFilialAgendamentoPendentes: { id: 0, name: "Selecione uma filial" },

      colunasTodosPedidos: [
        {
          key: "Número do Pedido",
          value: false
        },
        {
          key: "ID Produto",
          value: false
        },
        {
          key: "Código Numérico",
          value: false
        },
        {
          key: "Descrição do Produto",
          value: false
        },
      ],

      colunasFilterTagsTodosPedidos: [
        {
          key: "Data de emissão",
          value: "",
          origemValue: ""
        },
        {
          key: "Filial",
          value: "",
          origemValue: ""
        },
        {
          key: "Condição",
          value: "",
          origemValue: ""
        }
      ],

      colunasAgendamentoPendentes: [
        {
          key: "Número do Pedido",
          value: false
        },
        {
          key: "ID Produto",
          value: false
        },
        {
          key: "Código Numérico",
          value: false
        },
        {
          key: "Descrição do Produto",
          value: false
        },
      ],

      colunasFilterTagsAgendamentoPendentes: [
        {
          key: "Data de agendamento",
          value: "",
          origemValue: ""
        },
        {
          key: "Filial",
          value: "",
          origemValue: ""
        }
      ],

      opcoesFilial: [],
      opcoesCondicao: [],

      opcoesFiltroPedidos: [
        { id: "T", description: 'Todos' },
        { id: "P", description: 'Confirmação Pendente' },
        { id: "C", description: 'Agendamento Confirmado' },
        { id: "R", description: 'Agendamento Recusado' },
        { id: "E", description: 'Entrega Concluída' },
      ],
      opcoesFiltroPedidosValue: "T",

      /* Atributos da modal de filtro - End */

      /* Modal Detalhes do pedido - Begin*/
      isOpenModalTableAgendamentoPendentes: false,
      descriptionsModalTableAgendamentoPendentes: null,
      columnsAgendamentoPendentes: [
        {
          name: "productId",
          label: "ID Prod"
        },
        {
          name: "numericCode",
          label: "Cód num"
        },
        {
          name: "alphaId",
          label: "Alfa"
        },
        {
          name: "productName",
          label: "Nome do produto"
        },
        {
          name: "colorAbbreviation",
          label: "Cor"
        },
        {
          name: "scheduleQuantity",
          label: "Qtd"
        },
      ],
      itensTableAgendamentoPendentes: [],
      itensTableSelectedAgendamentoPendentes: [],
      pageModalAgendamentoPendentes: 0,
      countModalAgendamentoPendentes: 0,
      rowsPerPageModalAgendamentoPendentes: 4,
      rowsPerPageOptionsAgendamentoPendentes: [5, 10, 25, 50, 100],
      /* Modal Detalhes do pedido - End*/

      /* Modal agendamento pendente recusa - Begin*/
      openModalRecusaAgendamentoPendentes: false,
      /* Modal agendamento pendente recusa - End*/

      /* Modal agendamento pendente confirmar - Begin*/
      openModalConfirmarAgendamentoPendentes: false,
      /* Modal agendamento pendente confirmar - End*/

      itensPedidoConfirmados: [],
      itensPedidoConfirmadosSelected: [],
      isOpenModalConfirmaRecusa: false,

      /* Modal agendamento pendente motivos recusa - Begin*/
      openModalMotivoRecusaAgendamentoPendentes: false,
      escolhaMotivoRecusaAgendamentoPendentes: "",
      searchFieldExternalAgendamentoPendentes: 0,
      opcoesMotivosRecusa: [],
      /* Modal agendamento pendente motivos recusa - End*/

      /* Modal calendário agendamento pendente - Begin*/
      dataSugestaoEntrega: new Date(),
      openDialogCalendarAgendamentoPendentes: false,
      /* Modal calendário agendamento pendente - End*/

      /* Controle estado do pedido - Begin*/
      lastPedidoSelectedTodosPedidos: null,
      lastPedidoSelectedAgendamentoPendentes: null,
      /* Controle estado do pedido - End*/

      /* Modal nova opcao de todos pedidos - Begin*/
      openModalNovaOpcaoTodosPedidos: false,
      /* Modal nova opcao de todos pedidos - End*/

      /* Modal opcoes de pagmento todos pedidos - Begin*/
      openModalItensNovaOpcaoTodosPedidos: false,
      escolhaModalItensNovaOpcaoTodosPedidos: "",
      opcoesModalItensNovaOpcao: [],
      /* Modal opcoes de pagmento todos pedidos - End*/

      // protocolo agendamento - Begin
      detalhePedidoProtocolo: [],
      detalhePedidoProtocoloNF: [],
      infoPedidoProtocolo: {},
      rowsPerPagePedidoProtocolo: 5,
      totalRowsPedidoProtocolo: 0,
      rowsPerPageOptionsPedidoProtocolo: [5, 10, 25, 50, 100],

      // protocolo agendamento - end


      // Atributos da página
      title: props.route.title,
      isError: false,
      isLoading: false,
      error: "",
      //Entrega concluida
      dataEntregaConcluida: []

    };

    this.handlerChangeTab = this.handlerChangeTab.bind(this);
    this.handlerChangeFornec = this.handlerChangeFornec.bind(this);
    this.handlerChangeIndex = this.handlerChangeIndex.bind(this);

    this.loadTodosPedidos = this.loadTodosPedidos.bind(this);
    this.loadAgendamentoPendentes = this.loadAgendamentoPendentes.bind(this);
    this.loadMotivos = this.loadMotivos.bind(this);

    /* SEARCH FIELD PEDIDO */
    this.handleChangeSearchFieldPedidoTodosPedidos = this.handleChangeSearchFieldPedidoTodosPedidos.bind(this);
    this.handleChangeSearchFieldExternalPedidoTodosPedidos = this.handleChangeSearchFieldExternalPedidoTodosPedidos.bind(this);

    this.handleChangeSearchFieldPedidoAgendamentoPendentes = this.handleChangeSearchFieldPedidoAgendamentoPendentes.bind(this);
    this.handleClickSearchFieldAgendamentoPendentes = this.handleClickSearchFieldAgendamentoPendentes.bind(this);

    /* OPCOES BUSCA */
    this.handlerClickCheckboxTodosPedidos = this.handlerClickCheckboxTodosPedidos.bind(this);
    this.handlerClearCheckboxTodosPedidos = this.handlerClearCheckboxTodosPedidos.bind(this);
    this.handlerClearSearchFieldTodosPedidos = this.handlerClearSearchFieldTodosPedidos.bind(this);
    this.handlerAplicarFiltersTodosPedidos = this.handlerAplicarFiltersTodosPedidos.bind(this);
    this.handlerCleanFiltersTodosPedidos = this.handlerCleanFiltersTodosPedidos.bind(this);
    this.handlerDataTodosPedidosSelected = this.handlerDataTodosPedidosSelected.bind(this);

    this.handlerClickCheckboxAgendamentoPendentes = this.handlerClickCheckboxAgendamentoPendentes.bind(this);
    this.handlerClearCheckboxAgendamentoPendentes = this.handlerClearCheckboxAgendamentoPendentes.bind(this);
    this.handlerClearSearchFieldAgendamentoPendentes = this.handlerClearSearchFieldAgendamentoPendentes.bind(this);
    this.handlerAplicarFiltersAgendamentoPendentes = this.handlerAplicarFiltersAgendamentoPendentes.bind(this);
    this.handlerCleanFiltersAgendamentoPendentes = this.handlerCleanFiltersAgendamentoPendentes.bind(this);
    this.handlerJustCleanFiltersAgendamentosPendentes = this.handlerJustCleanFiltersAgendamentosPendentes.bind(this);

    /* OPCOES BUSCA TAGS */
    this.handlerClearFilterTagTodosPedidos = this.handlerClearFilterTagTodosPedidos.bind(this);
    this.handlerLoadSearchFilterTagTodosPedidos = this.handlerLoadSearchFilterTagTodosPedidos.bind(this);
    this.handlerChangeSearchFilterTagTodosPedidos = this.handlerChangeSearchFilterTagTodosPedidos.bind(this);

    this.handlerClearFilterTagAgendamentoPendentes = this.handlerClearFilterTagAgendamentoPendentes.bind(this);
    this.handlerLoadSearchFilterTagAgendamentoPendentes = this.handlerLoadSearchFilterTagAgendamentoPendentes.bind(this);
    this.handlerChangeSearchFilterTagAgendamentoPendentes = this.handlerChangeSearchFilterTagAgendamentoPendentes.bind(this);
    this.handlerLoadSearchFilterTagAgendamentoPendentes = this.handlerLoadSearchFilterTagAgendamentoPendentes.bind(this);

    /* CALENDAR */
    this.handlerChangeDateInitialTodosPedidos = this.handlerChangeDateInitialTodosPedidos.bind(this);
    this.handlerChangeDateEndTodosPedidos = this.handlerChangeDateEndTodosPedidos.bind(this);
    this.handlerChangeDateInitialAgendamentoPendentes = this.handlerChangeDateInitialAgendamentoPendentes.bind(this);
    this.handlerChangeDateEndAgendamentoPendentes = this.handlerChangeDateEndAgendamentoPendentes.bind(this);

    /* ESCOLHA DATA */
    this.handlerChangeRadioEscolhaDataTodosPedidos = this.handlerChangeRadioEscolhaDataTodosPedidos.bind(this);

    /* ESCOLHA FILIAL */
    this.handlerChangeEscolhaFilialTodosPedidos = this.handlerChangeEscolhaFilialTodosPedidos.bind(this);
    this.handlerChangeEscolhaFilialAgendamentoPendentes = this.handlerChangeEscolhaFilialAgendamentoPendentes.bind(this);

    /* FILTRO CONDICAO */
    this.handlerChangeEscolhaCondicaoTodosPedidos = this.handlerChangeEscolhaCondicaoTodosPedidos.bind(this);

    /* FILTRO PEDIDOS */
    this.handlerFiltroPedidos = this.handlerFiltroPedidos.bind(this);
    this.handlerCheckboxAllAgendamentoPendentes = this.handlerCheckboxAllAgendamentoPendentes.bind(this);
    this.handlerSelectCheckboxAgendamentoPendentes = this.handlerSelectCheckboxAgendamentoPendentes.bind(this);
    this.getFilters = this.getFilters.bind(this);

    /* PAGINATION */
    this.handlerOnChangeAgendamentoPendentes = this.handlerOnChangeAgendamentoPendentes.bind(this);
    this.changePageModalAgendamentoPendentes = this.changePageModalAgendamentoPendentes.bind(this);
    this.handlerChangePageTodosPedidos = this.handlerChangePageTodosPedidos.bind(this);
    this.handlerChangeRowsPerPageTodosPedidos = this.handlerChangeRowsPerPageTodosPedidos.bind(this);

    /* MODAL DETALHES DO AGENDAMENTO */
    this.loadDataModalAgendamentoPendentes = this.loadDataModalAgendamentoPendentes.bind(this);
    this.onRowsSelectAgendamentoPendetes = this.onRowsSelectAgendamentoPendetes.bind(this);
    this.handleDialogModalTableAgendamentoPendentes = this.handleDialogModalTableAgendamentoPendentes.bind(this);
    this.handleModalRecusaAgendamentoPendentes = this.handleModalRecusaAgendamentoPendentes.bind(this);
    this.handleModalConfirmarAgendamentoPendentes = this.handleModalConfirmarAgendamentoPendentes.bind(this);

    /* MODAL RECUSA AGENDAMENTO PENDENTE */
    this.handleModalRecusaCloseAgendamentoPendentes = this.handleModalRecusaCloseAgendamentoPendentes.bind(this);
    this.loadConfirmRefuseByList = this.loadConfirmRefuseByList.bind(this);
    this.loadConfirmRefuse = this.loadConfirmRefuse.bind(this);

    /* MODAL CONFIRMAR AGENDAMENTO PENDENTE */
    this.handleModalConfirmarCloseAgendamentoPendentes = this.handleModalConfirmarCloseAgendamentoPendentes.bind(this);
    this.handleImprimirAgendamentoPendentes = this.handleImprimirAgendamentoPendentes.bind(this);

    /* MODAL MOTIVOS RECUSA AGENDAMENTO PENDENTE */
    this.handleModalMotivoRecusaCloseAgendamentoPendentes = this.handleModalMotivoRecusaCloseAgendamentoPendentes.bind(this);
    this.handleModalMotivoRecusaChangeAgendamentoPendentes = this.handleModalMotivoRecusaChangeAgendamentoPendentes.bind(this);
    this.handleModalMotivoRecusaConfirmAgendamentoPendentes = this.handleModalMotivoRecusaConfirmAgendamentoPendentes.bind(this);
    this.handleModalConfirmarSelecionadosAgendamentoPendentes = this.handleModalConfirmarSelecionadosAgendamentoPendentes.bind(this);
    this.handlerChangeRowsPerPageAgendamentoPendentes = this.handlerChangeRowsPerPageAgendamentoPendentes.bind(this);

    /* MODAL CALENDÁRIO SUGESTAO DATA DE ENTREGA */
    this.handlerOnChangeDataSugestaoEntregaAgendamentoPendetes = this.handlerOnChangeDataSugestaoEntregaAgendamentoPendetes.bind(this);
    this.getDataSugestaoEntregaAgendamentoConfirmado = this.getDataSugestaoEntregaAgendamentoConfirmado.bind(this);
    this.handlerOpenDataSugestaoAgendamentoPendetes = this.handlerOpenDataSugestaoAgendamentoPendetes.bind(this);
    this.handlerConfirmarDataSugestaoAgendamentoPendetes = this.handlerConfirmarDataSugestaoAgendamentoPendetes.bind(this);

    /* ACTIONS */
    this.handlerConfirmarTodosSelecionadosAgendamentoPendentes = this.handlerConfirmarTodosSelecionadosAgendamentoPendentes.bind(this);
    this.handlerRecusarTodosSelecionadosAgendamentoPendentes = this.handlerRecusarTodosSelecionadosAgendamentoPendentes.bind(this);
    this.handlerBaixarEtiquetaTodosPedidos = this.handlerBaixarEtiquetaTodosPedidos.bind(this);
    this.handlerAlterarOpcaoPagTodosPedidos = this.handlerAlterarOpcaoPagTodosPedidos.bind(this);
    this.onColumnUpdateTodosPedidos = this.onColumnUpdateTodosPedidos.bind(this);

    this.handlerModalNovaOpcaoCloseTodosPedidos = this.handlerModalNovaOpcaoCloseTodosPedidos.bind(this);
    this.handlerModalNovaOpcaoEntendidoTodosPedidos = this.handlerModalNovaOpcaoEntendidoTodosPedidos.bind(this);

    this.handlerModalItensNovaOpcaoAplicarAlteracoesTodosPedidos = this.handlerModalItensNovaOpcaoAplicarAlteracoesTodosPedidos.bind(this);
    this.handlerModalItensNovaOpcaoCloseTodosPedidos = this.handlerModalItensNovaOpcaoCloseTodosPedidos.bind(this);
    this.handlerModalItensNovaOpcaoChangeTodosPedidos = this.handlerModalItensNovaOpcaoChangeTodosPedidos.bind(this);
    this.setState = this.setState.bind(this);
    this.shapeDataTodosPedidosSelectedEtiquetasObject = this.shapeDataTodosPedidosSelectedEtiquetasObject.bind(this);
    this.shapeEtiquetasObject = this.shapeEtiquetasObject.bind(this);
    this.getNomeProdutosSelectedEtiquetas = this.getNomeProdutosSelectedEtiquetas.bind(this);
    this.handleToggleCheckboxEtiquetasTodosPedidos = this.handleToggleCheckboxEtiquetasTodosPedidos.bind(this);
    this.handleDataTodosPedidosSelectedEtiquetas = this.handleDataTodosPedidosSelectedEtiquetas.bind(this);
    this.handlerDataSetTagTodosPedidos = this.handlerDataSetTagTodosPedidos.bind(this);
    /* ENTREGA CONCLUIDA */
    this.heandleExtendChangeEntregaConcluida = this.heandleExtendChangeEntregaConcluida.bind(this);

    this.handlerCallCleanTodosPedidos = this.handlerCallCleanTodosPedidos.bind(this);
  };

  componentWillMount() {
    this.permissions = this.context.user.permissions;

    this.setState({
      columnsAgendamentoPendentes: [
        {
          name: "CONFIRM_AGENDAMENTO",
          options: {
            display: !!this.permissions["gerenciar-pedidos.recusa-confirmacao"],
            filter: false,
            download: false,
            customHeadRender: ({ index, ...column }) => {
              return (
                CheckAllCheckbox(
                  this.state.itensTableSelectedAgendamentoPendentes,
                  this.state.countModalAgendamentoPendentes,
                  this.onAllRowsSelectAgendamentoPendetes
                )
              );
            },
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                ConfirmCheckbox(
                  value, tableMeta, updateValue,
                  this.state.itensTableSelectedAgendamentoPendentes,
                  this.onRowsSelectAgendamentoPendetes
                )
              );
            },
          }
        },
        ...this.state.columnsAgendamentoPendentes,
      ]
    });
  }

  componentDidMount() {
    this.isVisaoTok = this.context.user.isVisaoTok;
    this.loadDateOnStartScreen()
    this.loadData();
  };

  loadDateOnStartScreen() { // SOUR-1414
    this.setState({
      escolhaDataTodosPedidos: "dtEmissao",
      dtInitialTodosPedidos: moment().subtract(730, 'days').toDate(),
      dtEndTodosPedidos: moment().toDate(),
    });

    this.handlerDataSetTagTodosPedidos()
  }

  async loadData() {
    await this.loadSequence();
    if (this.isVisaoTok) {
      await this.loadFornecedores();
    }
    await this.loadDataPessoa();
    await this.loadOpcaoPagmento();
    await this.loadCondicao();
    await this.loadFilial();

    await this.handlerLoadSearchFilterTagTodosPedidos();
    await this.handlerLoadSearchFilterTagAgendamentoPendentes();

    //TODO - Solução paleativa até ser definido a forma que iremos chamar a tela de pendentes
    if (this.props.routeParams.tabId === "1" &&
      this.permissions["gerenciar-pedidos.pendentes"]) {
      this.handlerChangeIndex(1);
    }
    if (this.props.routeParams.tabId === "4" &&
      this.permissions["gerenciar-pedidos.protocolo-agendamento"]) {
      this.handlerChangeIndex(4);
    }

    const colTodosPedidos = ColTodosPedidos(
      this.handlerOpcoesRecebimentoTodosPedidos,
      this.handleToggleCheckboxEtiquetasTodosPedidos,
      this.handleDataTodosPedidosSelectedEtiquetas,
      this.props,
    )

    this.setState({ columnsTodosPedidos: colTodosPedidos });

    //auditoria
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    Log.info(token, `Efetuado carregamento da tela gerenciar pedidos de ${this.props.route.title}!`);
  };

  async loadFornecedores() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    try {
      const r_fornecedores = await GerenciarPedidos_controller.getSuppliers(token);
      const j_r_fornecedores = JSON.parse(r_fornecedores.body);
      if (r_fornecedores.res.statusCode === 200) {
        this.setState({ fornecedores: j_r_fornecedores });

      } else {
        if (
          j_r_fornecedores.status == false &&
          j_r_fornecedores.message &&
          j_r_fornecedores.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Ocorreu um problema ao carregar a listagem de fornecedores. Por favor, tente novamente.");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }

  };
  getFilters() {
    return this.state
  }

  async loadCondicao() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    //const personId = cookies.get('User-Code');
    const personId = this.state.fornecedor

    try {
      const r_condicoes = await GerenciarPedidos_controller.paymentConditionsList(token, personId);
      const j_r_condicoes = JSON.parse(r_condicoes.body);
      if (r_condicoes.res.statusCode === 200) {
        let array = [{ id: 0, name: "Selecione uma condições" }];
        let arrayItens = j_r_condicoes.map(element => {
          return {
            id: element.paymentId,
            name: `${element.deadlineDays} dias - (${element.nameConditionPayment})`
          };
        });

        this.setState({ opcoesCondicao: array.concat(arrayItens) });
      } else {
        if (
          j_r_condicoes.status == false &&
          j_r_condicoes.message &&
          j_r_condicoes.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => { window.location.reload() }, 1000);
        } else {
          throw new Error("Campos necessários, não foram retornados pelo servidor!");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }

  };

  async loadFilial() {
    try {
      const cookies = new Cookies();
      const token = cookies.get('User-Token');
      const r_filiais = await GerenciarPedidos_controller.getFiliais(token);
      const j_r_filiais = JSON.parse(r_filiais.body);
      if (r_filiais.res.statusCode === 200) {
        let array = [{ id: 0, name: "Selecione uma filial" }];
        let arrayItens = j_r_filiais.map(element => {
          return {
            id: element.branchId,
            name: `${element.branchId} - ${element.externalBranchName}`
          };
        });
        this.setState({ opcoesFilial: array.concat(arrayItens) });
      } else {
        if (
          j_r_filiais.status == false &&
          j_r_filiais.message &&
          j_r_filiais.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => { window.location.reload() }, 1000);
        } else {
          throw new Error("Campos necessários, não foram retornados pelo servidor!");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }

  };

  async loadDataPessoa() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      const o_pessoa = await Pessoas_controller.getByToken(token);
      let j_pessoa = JSON.parse(o_pessoa.body);
      if (o_pessoa.res.statusCode === 200) {
        this.setState({ fornecedor: j_pessoa.itens.codigo });

        //auditoria
        let str = `Efetuada requisição para retorno de dados de pessoa!
                Response:( Method: ${o_pessoa.res.request.method}
                , StatusCode: ${o_pessoa.res.statusCode}
                , Body: (limited 100chars)${o_pessoa.body.substr(0, 100)} )`;
        Log.info(token, str);
      } else {
        throw new Error("Ocorreu um problema ao carregar as informações do usuário. Por favor, tente novamente.");
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }
  };

  isInt(value) {
    return !isNaN(value) &&
      parseInt(Number(value)) == value &&
      !isNaN(parseInt(value, 10));
  }

  async loadTodosPedidos({ linha_inicial, qtd_registro, tipo_load }) {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {

      let dt_emis_inic = null;
      let dt_emis_fim = null;
      let dt_agenda_inic = null;
      let dt_agenda_fim = null;

      let nr_pc = null;
      let id_prod = null;
      let cd_num = null;
      let nm_prod = null;
      let cd_fil = "";
      let cd_con = "";

      const arrayColNrPcTag = this.state.colunasFilterTagsTodosPedidos
        .filter(element => (
          element.key === "Número do Pedido" &&
          element.value !== element.origemValue
        ));

      const arrayColNrProdTag = this.state.colunasFilterTagsTodosPedidos
        .filter(element => (
          element.key === "ID Produto" &&
          element.value !== element.origemValue
        ));

      const arrayColCdNumTag = this.state.colunasFilterTagsTodosPedidos
        .filter(element => (
          element.key === "Código Numérico" &&
          element.value !== element.origemValue
        ));

      const arrayColDsProdTag = this.state.colunasFilterTagsTodosPedidos
        .filter(element => (
          element.key === "Descrição do Produto" &&
          element.value !== element.origemValue
        ));

      const arrayDatasTags = this.state.colunasFilterTagsTodosPedidos.filter((element) => (element?.key == 'Data de emissão' || element?.key == 'Data de agendamento') && element.value != element.origemValue);

      const arrayColFilialTag = this.state.colunasFilterTagsTodosPedidos
        .filter(element => (
          element.key === "Filial" &&
          element.value !== element.origemValue
        ));

      const arrayColCondicaoTag = this.state.colunasFilterTagsTodosPedidos
        .filter(element => (
          element.key === "Condição" &&
          element.value !== element.origemValue
        ));

      if (arrayColNrPcTag.length > 0) {
        nr_pc = parseInt(arrayColNrPcTag[0].value);

        if (!this.isInt(nr_pc)) {
          this.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
          return;
        }
      }

      if (arrayColNrProdTag.length > 0) {
        id_prod = parseInt(arrayColNrProdTag[0].value);

        if (!this.isInt(id_prod)) {
          this.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
          return;
        }
      }

      if (arrayColCdNumTag.length > 0) {
        cd_num = parseInt(arrayColCdNumTag[0].value);

        if (!this.isInt(cd_num)) {
          this.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
          return;
        }
      }

      if (arrayColDsProdTag.length > 0 && !this.isInt(this.state.searchFieldTodosPedidos)) {
        nm_prod = arrayColDsProdTag[0].value;
      }

      if (arrayColFilialTag.length > 0) {
        cd_fil = arrayColFilialTag[0].value;
      }

      if (arrayColCondicaoTag.length > 0) {
        cd_con = arrayColCondicaoTag[0].value;
      }

      const searchFieldExternal = this.state.searchFieldExternalTodosPedidos
      const isInt = this.isInt(searchFieldExternal)

      if (isInt) {
        nr_pc = searchFieldExternal;
      }

      if (searchFieldExternal !== '' && !isInt) {
        nm_prod = this.state.searchFieldExternalTodosPedidos;
      }

      if (tipo_load == "applyFilters") {
        if (
          arrayColNrPcTag.length == 0 &&
          arrayColNrProdTag.length == 0 &&
          arrayColCdNumTag.length == 0 &&
          arrayColDsProdTag.length == 0 &&
          this.state.searchFieldTodosPedidos != ""
        ) {
          this.setState({ searchFieldTodosPedidos: "" });
        }
      }
      if (arrayDatasTags.length > 0) {
        if (this.state.escolhaDataTodosPedidos == "dtEmissao") {
          dt_emis_inic = moment(this.state.dtInitialTodosPedidos).format("DD/MM/YYYY");
          dt_emis_fim = moment(this.state.dtEndTodosPedidos).format("DD/MM/YYYY");
        } else {
          dt_agenda_inic = moment(this.state.dtInitialTodosPedidos).format("DD/MM/YYYY");
          dt_agenda_fim = moment(this.state.dtEndTodosPedidos).format("DD/MM/YYYY");
        }
      }

      let filters = {
        personId: this.state.fornecedor,
        initialRow: linha_inicial,
        nextRows: qtd_registro,
        statusSciaIs: this.state.opcoesFiltroPedidosValue
      };

      if (nr_pc != null) {
        filters = { ...filters, purchaseOrderId: nr_pc };
      }

      if (id_prod != null) {
        filters = { ...filters, productId: id_prod };
      }
      if (cd_num != null) {
        filters = { ...filters, numericCode: cd_num };
      }
      if (nm_prod != null) {
        filters = { ...filters, productName: nm_prod };
      }
      if (dt_emis_inic != null) {
        filters = { ...filters, initialIssueDate: dt_emis_inic };
      }
      if (dt_emis_fim != null) {
        filters = { ...filters, finalIssueDate: dt_emis_fim };
      }
      if (dt_agenda_inic != null) {
        filters = { ...filters, initialScheduleDate: dt_agenda_inic };
      }
      if (dt_agenda_fim != null) {
        filters = { ...filters, finalScheduleDate: dt_agenda_fim };
      }
      if (cd_fil !== "") {
        filters = { ...filters, branchId: cd_fil };
      }
      if (cd_con !== "") {
        filters = { ...filters, paymentId: cd_con };
      }
      const r_pedidos = await GerenciarPedidos_controller.getPedidos(token, filters);
      const j_r_pedidos = JSON.parse(r_pedidos.body);
      if (r_pedidos.res.statusCode === 200) {
        let arrayItens = j_r_pedidos.map(element => {
          return {
            ...element,
            paymentId: `${element.paymentId} dias`,
            unitaryValue: formatCurrencytoBr(element.unitaryValue),
            amount: formatCurrencytoBr(element.amount),
            outstandingAmount: formatCurrencytoBr(element.outstandingAmount),
            percentDiscont: `${element.percentDiscont}%`,
            percentValueIPI: `${element.percentValueIPI}%`,
            monetaryDiscont: formatCurrencytoBr(element.monetaryDiscont),
            monetaryPenaltySchedule: formatCurrencytoBr(element.monetaryPenaltySchedule),
            netDiscount: formatCurrencytoBr(element.netDiscount),
            opcoes_recebimento: element,
            historico_agendamento: {
              purchaseOrderId: element.purchaseOrderId,
              productId: element.productId,
              deliveryDate: element.deliveryDate.split("/").join("-"),
              branchId: element.branchId,
            }
          };
        });

        await this.setState({ dataTodosPedidos: arrayItens });
        if (arrayItens.length > 0) {
          this.setState({ qtdTodosPedidos: parseInt(arrayItens[0].totalRows) });
        } else {
          this.setState({ qtdTodosPedidos: 0 });
        }

      } else {
        if (
          j_r_pedidos.status == false &&
          j_r_pedidos.message &&
          j_r_pedidos.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Ocorreu um problema ao carregar as informações da tabela de pedidos. Por favor, tente novamente.");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }
  };

  async loadAgendamentoPendentes({ linhaInicial, qtdRegistro, nrPc, tipo_load }) {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const color = cookies.get('System-Color');

    try {

      let dt_agenda_inic = null;
      let dt_agenda_fim = null;
      let nr_pc = null;
      let id_prod = null;
      let cd_num = null;
      let nm_prod = null;
      let cd_fil = "";

      const arrayColNrPcTag = this.state.colunasFilterTagsAgendamentoPendentes
        .filter(element => (
          element.key === "Número do Pedido" &&
          element.value !== element.origemValue
        ));

      const arrayColNrProdTag = this.state.colunasFilterTagsAgendamentoPendentes
        .filter(element => (
          element.key === "ID Produto" &&
          element.value !== element.origemValue
        ));

      const arrayColCdNumTag = this.state.colunasFilterTagsAgendamentoPendentes
        .filter(element => (
          element.key === "Código Numérico" &&
          element.value !== element.origemValue
        ));

      const arrayColDsProdTag = this.state.colunasFilterTagsAgendamentoPendentes
        .filter(element => (
          element.key === "Descrição do Produto" &&
          element.value !== element.origemValue
        ));

      const arrayDatasTags = this.state.colunasFilterTagsAgendamentoPendentes
        .filter(element => (
          element.key === "Data de agendamento" &&
          element.value !== element.origemValue
        ));

      const arrayColFilialTag = this.state.colunasFilterTagsAgendamentoPendentes
        .filter(element => (
          element.key === "Filial" &&
          element.value !== element.origemValue
        ));

      if (arrayColNrPcTag.length > 0) {
        nr_pc = parseInt(arrayColNrPcTag[0].value);

        if (!this.isInt(nr_pc)) {
          this.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
          return;
        }
      }

      if (arrayColNrProdTag.length > 0) {
        id_prod = parseInt(arrayColNrProdTag[0].value);

        if (!this.isInt(id_prod)) {
          this.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
          return;
        }
      }

      if (arrayColCdNumTag.length > 0) {
        cd_num = parseInt(arrayColCdNumTag[0].value);

        if (!this.isInt(cd_num)) {
          this.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
          return;
        }
      }

      if (arrayColDsProdTag.length > 0 && !this.isInt(this.state.searchFieldAgendamentoPendentes)) {
        nm_prod = arrayColDsProdTag[0].value;
      }

      if (arrayColFilialTag.length > 0) {
        cd_fil = arrayColFilialTag[0].value;
      }

      if (tipo_load == "searchField") {
        if (this.isInt(nrPc)) {
          nr_pc = nrPc;
        } else {
          nm_prod = nrPc;
        }
      } else if (tipo_load == "applyFilters") {
        if (
          arrayColNrPcTag.length == 0 &&
          arrayColNrProdTag.length == 0 &&
          arrayColCdNumTag.length == 0 &&
          arrayColDsProdTag.length == 0 &&
          this.state.searchFieldAgendamentoPendentes != ""
        ) {
          await this.setState({ searchFieldAgendamentoPendentes: "" });
        }
      }

      if (arrayDatasTags.length > 0) {
        dt_agenda_inic = moment(this.state.dtInitialAgendamentoPendentes).format("DD/MM/YYYY");
        dt_agenda_fim = moment(this.state.dtEndAgendamentoPendentes).format("DD/MM/YYYY");
      }

      let filters = {
        personId: this.state.fornecedor,
        initialRow: linhaInicial,
        nextRows: qtdRegistro,
        statusSciaIs: 'P'
      };
      if (nr_pc != null) {
        filters = { ...filters, purchaseOrderId: nr_pc };
      }
      if (id_prod != null) {
        filters = { ...filters, productId: id_prod };
      }
      if (cd_num != null) {
        filters = { ...filters, numericCode: cd_num };
      }
      if (nm_prod != null) {
        filters = { ...filters, productName: nm_prod };
      }
      if (dt_agenda_inic != null) {
        filters = { ...filters, initialScheduleDate: dt_agenda_inic };
      }
      if (dt_agenda_fim != null) {
        filters = { ...filters, finalScheduleDate: dt_agenda_fim };
      }
      if (cd_fil !== "") {
        filters = { ...filters, branchDeliveryId: cd_fil };
      }
      const r_pedidos = await getPedidosAgendados(token, filters);
      const j_r_pedidos = JSON.parse(r_pedidos.body);
      if (r_pedidos.res.statusCode === 200) {
        const arrayItens = j_r_pedidos.map(e => {
          this.setState({ qtdAgendamentoPendentes: e.totalRows });
          const dtAgenda = e.scheduleDate;
          return {
            nr_pedido: e.purchaseOrderId,
            dt_agendamento: dtAgenda,
            ds_filial: `${e.branchDeliveryId} - ${e.branchName}`,
            cd_filial: e.branchDeliveryId,
            bt_component: [
              {
                label: "VER DETALHES DO PEDIDO",
                variant: "contained",
                handler: async () => {
                  await this.setState({
                    isLoading: true,
                    pageModalAgendamentoPendentes: 0
                  });
                  await this.loadDataModalAgendamentoPendentes({
                    cdFil: e.branchDeliveryId,
                    nrPc: e.purchaseOrderId,
                    dtAgenda,
                    inStatus: 'P',
                    linhaInicial: 0,
                    qtdRegistro: this.state.rowsPerPageModalAgendamentoPendentes,
                  });
                  let total = 0;
                  if (this.state.itensTableAgendamentoPendentes.length > 0) {
                    total = parseInt(this.state.itensTableAgendamentoPendentes[0].totalRows);
                  }
                  await this.setState({
                    countModalAgendamentoPendentes: total,
                    lastPedidoSelectedAgendamentoPendentes: e,
                    descriptionsModalTableAgendamentoPendentes: {
                      nr_pedido: e.purchaseOrderId,
                      dt_agendamento: dtAgenda,
                      ds_filial: `${e.branchDeliveryId} - ${e.branchName}`,
                      e: e
                    }
                  });
                  await this.handleDialogModalTableAgendamentoPendentes();
                  await this.setState({ isLoading: false });
                }
              }
            ],
            Ds_msg_alert: (className) => {
              return (
                <div style={{ color: ((color === 'light') ? "red" : "white") }}>
                  A confirmação de agendamento deste pedido irá <b>expirar em {e.QT_DIAS_PRAZO} dia(s)</b>
                </div>
              );
            },
            ds_msg: e.IN_ALTEROU_AGENDA === "S"
              ? "Houve alteração na data de agendamento deste pedido"
              : null,
          };
        });
        this.setState({ dataAgendamentoPendentes: arrayItens, isLoading: false });
        // this.setState({ qtdAgendamentoPendentes: arrayItens[0].qtd_regs, isLoading: false });

      } else {
        if (
          j_r_pedidos.status == false &&
          j_r_pedidos.message &&
          j_r_pedidos.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Ocorreu um problema ao carregar as informações da tabela de pedidos. Por favor, tente novamente.");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }
  };

  async loadMotivos() {
    try {
      const cookies = new Cookies();
      const token = cookies.get('User-Token');
      const r_motivo = await GerenciarPedidos_controller.getMotivo(token);
      const j_r_motivo = JSON.parse(r_motivo.body);
      if (r_motivo.res.statusCode === 200) {
        const arrayItens = j_r_motivo.map(e => {
          return {
            id: e.reasonId,
            title: e.reasonName,
          };
        });
        this.setState({
          opcoesMotivosRecusa: arrayItens,
        });

      } else {
        if (
          j_r_motivo.status == false &&
          j_r_motivo.message &&
          j_r_motivo.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Ocorreu um problema ao carregar as informações. Por favor, tente novamente.");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }

  };

  async loadOpcaoPagmento() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      if (this.state.fornecedor) {
        const filters = {
          idFornecedor: this.state.fornecedor
        };
        const r_condicao = await OpcoesRecebimentoController.getDescontos(token, filters);
        const j_r_condicao = JSON.parse(r_condicao.body);
        if (r_condicao.res.statusCode === 200) {
          const arrayItens = j_r_condicao.map(e => {
            return {
              id: parseInt(e.paymentId),
              title: e.IN_COND_PADRAO_FORNEC === "N" ? `${e.NR_PRAZO1} dias após a entrega, desconto de ${e.VP_DESC_ANTEC_PAGTO}%` : "Cancelar antecipação",
              titleStyle: { fontWeight: 'bold' },
            };
          });
          this.setState({
            opcoesModalItensNovaOpcao: arrayItens,
            checkPermissionOpcoesRecebimento: true
          });

        } else if (r_condicao.res.statusCode !== 406) {
          if (
            j_r_condicao.status == false &&
            j_r_condicao.message &&
            j_r_condicao.message.includes("Token inválido!")
          ) {
            this.childAlerta.current.retorno('Autentificação inválida!', 'error');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            throw new Error("Ocorreu um problema ao carregar as informações. Por favor, tente novamente.");
          }
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }

  };

  async loadConfirmRefuse({
    cdFil,
    nrPc,
    IdProd,
    dtAgenda,
    inStatus,
    idMotivoRecusa,
    dtAgeSugFornec,
    dtEntrega,
  }) {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const allOrders = this.state.dataTodosPedidos[0];

    try {
      const body = {
        // personId: parseInt(this.state.fornecedor),
        personId: window.usuario?.codigo,
        scheduleDate: (dtAgenda != null ? dtAgenda : null),
        scheduleSuggestionDate: (dtAgeSugFornec != null ? (moment(dtAgeSugFornec).format('DD/MM/YYYY')) : null),
        deliveryDate: dtEntrega ? dtEntrega.split(' ')[0] : null,
        branchId: allOrders.branchId,
        purchaseOrderId: nrPc,
        productId: IdProd,
        statusIs: inStatus,
        reasonRefuseId: idMotivoRecusa,
      };
      const r_ConfirmRecusa = await GerenciarPedidos_controller.postConfirmRefuse(token, body);
      if (r_ConfirmRecusa.res.statusCode === 201) {
        this.setState({ isLoading: false });
        return true;
      } else {
        const j_r_ConfirmRecusa = JSON.parse(r_ConfirmRecusa.body);
        if (
          j_r_ConfirmRecusa.message &&
          j_r_ConfirmRecusa.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (j_r_ConfirmRecusa.error != null) {
          this.setState({ isLoading: false });
          this.childAlerta.current.retorno(j_r_ConfirmRecusa.message, 'error');
          return false;
        } else {
          throw new Error("Erro ao processar dados no servidor!");
        }
      }
    } catch (error) {
      let errorString = "Erro ao enviar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
      return false;
    }
  };


  async loadConfirmRefuseByList(orders) {

    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      const body = [];
      const allOrders = this.state.dataTodosPedidos[0];
      orders.map((order) => {
        body.push({
          personId: window.usuario?.codigo,
          scheduleDate: (order.dtAgenda != null ? order.dtAgenda : null),
          scheduleSuggestionDate: (order.dtAgeSugFornec != null ? (moment(order.dtAgeSugFornec).format('DD/MM/YYYY')) : null),
          deliveryDate: order.dtEntrega ? order.dtEntrega.split(' ')[0] : null,
          branchId: allOrders.branchId,
          purchaseOrderId: order.nrPc,
          productId: order.IdProd,
          statusIs: order.inStatus,
          reasonRefuseId: order.idMotivoRecusa,
        })
      });

      const r_ConfirmRecusa = await GerenciarPedidos_controller.postConfirmRefuseByList(token, body);
      if (r_ConfirmRecusa.res.statusCode === 201) {
        this.setState({ isLoading: false });
        return true;
      } else {
        const j_r_ConfirmRecusa = JSON.parse(r_ConfirmRecusa.body);
        if (
          j_r_ConfirmRecusa.message &&
          j_r_ConfirmRecusa.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (j_r_ConfirmRecusa.error != null) {
          this.setState({ isLoading: false });
          this.childAlerta.current.retorno(j_r_ConfirmRecusa.message, 'error');
          return false;
        } else {
          throw new Error("Erro ao processar dados no servidor!");
        }
      }
    } catch (error) {
      let errorString = "Erro ao enviar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      console.log(error);
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
      return false;
    }
  };

  async loadAtualizaOpcaoPagmento({
    purchaseOrderId, branchDeliveryId, productId, DT_ENTR
  }) {
    //instancia cookies e captura user-token para fazer request
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      //recupera dados de grupos
      const body = {
        id_pessoa: this.state.fornecedor,
        nr_pc: purchaseOrderId,
        cd_fil: branchDeliveryId,
        id_prod: productId,
        dt_entrg: DT_ENTR.split(' ')[0],
        cd_pagto: this.state.escolhaModalItensNovaOpcaoTodosPedidos
      };
      const r_condicao = await OpcoesRecebimentoController.put(token, body);

      //convert dados de condicaos para object
      const j_r_condicao = JSON.parse(r_condicao.body);

      //valida resultado da consulta
      if (r_condicao.res.statusCode === 200) {
        this.setState({ escolhaModalItensNovaOpcaoTodosPedidos: "" });
        return true;
      } else {
        if (
          j_r_condicao.message &&
          j_r_condicao.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (j_r_condicao.error != null) {
          this.setState({ isLoading: false });
          this.childAlerta.current.retorno(j_r_condicao.error, 'error');
          return false;
        } else {
          throw new Error("Erro ao processar dados no servidor!");
        }
      }
    } catch (error) {
      this.childAlerta.current.retorno('Erro na edição de dados de condições!', 'error');

      //auditoria
      let str = "Erro na edição de dados de condições! "
        + "Error:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
      return false;
    }
  };

  async loadDataModalAgendamentoPendentes({ cdFil, nrPc, dtAgenda, inStatus, linhaInicial, qtdRegistro }) {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      let filters = {
        personId: this.state.fornecedor,
        initialScheduleDate: (dtAgenda != null ? dtAgenda : null),
        finalScheduleDate: (dtAgenda != null ? dtAgenda : null), // SOUR-1415
        branchId: cdFil,
        purchaseOrderId: nrPc,
        statusSciaIs: inStatus,
        initialRow: linhaInicial,
        nextRows: qtdRegistro
      };
      const r_itensPedido = await GerenciarPedidos_controller.getPedidos(token, filters);
      const j_r_itensPedido = JSON.parse(r_itensPedido.body);
      if (r_itensPedido.res.statusCode === 200) {
        const arrayItens = j_r_itensPedido.map(e => {
          return {
            ...e,
            CONFIRM_AGENDAMENTO: e,
          };
        });
        let total = 0;
        if (arrayItens.length > 0) {
          total = parseInt(arrayItens[0].totalRows);
        }
        this.setState({
          itensTableAgendamentoPendentes: arrayItens,
          countModalAgendamentoPendentes: total,
        });
      } else {
        if (
          j_r_itensPedido.status == false &&
          j_r_itensPedido.message &&
          j_r_itensPedido.message.includes("Token inválido!")
        ) {
          this.childAlerta.current.retorno('Autentificação inválida!', 'error');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Ocorreu um problema ao carregar as informações. Por favor, tente novamente.");
        }
      }
    } catch (error) {
      let errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });
      this.childAlerta.current.retorno(error.message, 'error');
    }
  };

  async loadSequence() {
    if (this.permissions["gerenciar-pedidos.todos-pedidos"]) {
      this.setState({ valueTab: 0 });
      return;
    }
    if (this.permissions["gerenciar-pedidos.pendentes"]) {
      this.setState({ valueTab: 1 });
      return;
    }
    if (this.permissions["gerenciar-pedidos.confirmados"]) {
      this.setState({ valueTab: 2 });
      return;
    }
    if (this.permissions["gerenciar-pedidos.recusados"]) {
      this.setState({ valueTab: 3 });
      return;
    }
    if (this.permissions["gerenciar-pedidos.protocolo-agendamento"]) {
      this.setState({ valueTab: 4 });
      return;
    }
    if (this.permissions["gerenciar-pedidos.entregas-concluidas"]) {
      this.setState({ valueTab: 5 });
      return;
    }
    if (this.permissions["gerenciar-pedidos.retiradas-pendentes"]) {
      this.setState({ valueTab: 6 });
      return;
    }
  };

  handlerChangeTab = (event, newValue) => {
    this.setState({ valueTab: newValue });

    if (newValue == 0) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:aba',
          eventLabel: 'todos-pedidos',
        }
      });
    }
    if (newValue == 1) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:aba',
          eventLabel: 'agendamentos-pendentes',
        }
      });
    }
    if (newValue == 2) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:aba',
          eventLabel: 'agendamentos-confirmados',
        }
      });
    }
    if (newValue == 3) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:aba',
          eventLabel: 'agendamentos-recusados',
        }
      });
    }
    if (newValue == 4) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:aba',
          eventLabel: 'protocolo-agendamentos',
        }
      });
    }
    if (newValue == 5) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:aba',
          eventLabel: 'entregas-concluidas',
        }
      });
    }
  };

  handlerChangeIndex = (index) => {
    this.setState({ valueTab: index });
  };

  //Entrega concluida
  heandleExtendChangeEntregaConcluida = (newLisDataEntregaConcluida) => {
    this.setState({ dataEntregaConcluida: newLisDataEntregaConcluida })
  }

  handlerDataTodosPedidosSelected = (i) => {
    const value = this.state.dataTodosPedidos[i];
    let newDataTodosPedidosSelected = this.state.dataTodosPedidosSelected;
    let newDataTodosPedidosIndexSelected = this.state.dataTodosPedidosIndexSelected;

    const index = newDataTodosPedidosSelected.indexOf(value);
    if (index > -1) {
      newDataTodosPedidosSelected.splice(index, 1);
    } else {
      newDataTodosPedidosSelected.push(value);
    }

    const index2 = newDataTodosPedidosIndexSelected.indexOf(i);
    if (index2 > -1) {
      newDataTodosPedidosIndexSelected.splice(index2, 1);
    } else {
      newDataTodosPedidosIndexSelected.push(i);
    }

    this.setState({
      dataTodosPedidosIndexSelected: newDataTodosPedidosIndexSelected,
      dataTodosPedidosSelected: newDataTodosPedidosSelected,
      lastPedidoSelectedTodosPedidos: null
    });
  };

  handleClickSearchFieldTodosPedidos = async () => {
    await this.setState({ isLoading: true });
    await this.loadTodosPedidos({
      linha_inicial: 0,
      qtd_registro: this.state.pageRowsTodosPedidos,
      tipo_load: "searchField"
    });
    await this.setState({ isLoading: false });
  };

  handleClickSearchFieldAgendamentoPendentes = async () => {
    this.setState({ firstLoad: true });
    let colunas = this.state.colunasAgendamentoPendentes;
    let colunasFilter = this.state.colunasFilterTagsAgendamentoPendentes;

    if (this.state.colunasAgendamentoPendentes[0].value === true) {
      colunas[0].value = false;
      colunasFilter[2].value = '';

      await this.loadAgendamentoPendentes({
        linhaInicial: 0,
        qtdRegistro: this.state.pageRowsAgendamentoPendentes,
        nrPc: '',
        tipo_load: 'searchField'
      });

      this.setState({
        searchFieldAgendamentoPendentes: '',
      })
    }
    else {
      await this.loadAgendamentoPendentes({
        linhaInicial: 0,
        qtdRegistro: this.state.pageRowsAgendamentoPendentes,
        nrPc: this.state.searchFieldAgendamentoPendentes,
        tipo_load: 'searchField'
      });

      colunas[0].value = true;
      colunasFilter[2].value = this.state.searchFieldAgendamentoPendentes;
    }

    return this.setState({
      colunasAgendamentoPendentes: colunas,
      colunasFilterTagsAgendamentoPendentes: colunasFilter,
      isLoading: false,
      firstLoad: false
    });
  };

  handlerChangeFornec = async (event, value) => {
    this.setState({
      dataTodosPedidosSelectedEtiquetas: [],
      dataTodosPedidos: [],
      isLoading: true,
    });
    let fornec = null;
    let fornecName = null;
    this.handlerClearEscolhaCondicaoTodosPedidos();
    this.handlerClearFilterTagsButKeepDates(); // SOUR 1407
    this.handlerClearCheckboxTodosPedidos();
    //TODO quando for refatorar manter o objeto com id e nome
    if (value == null) {
      this.setState({
        fornecedor: null,
        fornecedorName: '',
        firstLoad: false,
        valueTab: 0,
        qtdAgendamentoPendentes: 0
      });
    } else {
      fornec = value.personId;
      fornecName = value.supplierName;
      this.setState({
        fornecedor: fornec,
        fornecedorName: fornecName,
        firstLoad: true,
      });
      await this.loadOpcaoPagmento();
      await this.loadCondicao();
    }
  };

  handlerDataLoad = async (value) => {
    await this.setState({ firstLoad: true });
    if (this.permissions["gerenciar-pedidos.todos-pedidos"]) {
      await this.loadMotivos();
    }

    await this.loadAgendamentoPendentes({
      linhaInicial: 0,
      qtdRegistro: this.state.pageRowsAgendamentoPendentes,
      tipo_load: "firstLoad"
    });

    await this.setState({
      itensTableSelectedAgendamentoPendentes: [],
      dataTodosPedidosSelected: [],
      dataAgendamentoPendentesSelected: [],
      firstLoad: false,
    });
  };

  /* OPCOES BUSCA - Begin */

  /* CHECKBOX PEDIDO - Begin */

  /* TODOS PEDIDOS - Begin */
  handlerClickCheckboxTodosPedidos = (i) => {

    if (this.state.searchFieldTodosPedidos == "") {
      this.childAlerta.current.retorno('Digite algum valor no campo!', 'warning');
      return;
    }

    let colunms = this.state.colunasTodosPedidos;
    colunms[i].value = !(this.state.colunasTodosPedidos[i].value);
    this.setState({ colunasTodosPedidos: colunms });

    this.handlerChangeSearchFilterTagTodosPedidos(i);
  };

  handlerClearCheckboxTodosPedidos = () => {
    let colunms = this.state.colunasTodosPedidos;
    this.state.colunasTodosPedidos.forEach(element => {
      element.value = false;
    });
    this.setState({ colunasTodosPedidos: colunms });
  };
  /* TODOS PEDIDOS - End */

  /* CONFIRMACAO PENDENTE - Begin */
  handlerClickCheckboxAgendamentoPendentes = (i) => {
    let colunms = this.state.colunasAgendamentoPendentes;
    colunms[i].value = !(this.state.colunasAgendamentoPendentes[i].value);
    this.setState({ colunasAgendamentoPendentes: colunms });

    this.handlerChangeSearchFilterTagAgendamentoPendentes(i);
  };

  handlerClearCheckboxAgendamentoPendentes = () => {
    let colunms = this.state.colunasAgendamentoPendentes;
    this.state.colunasAgendamentoPendentes.forEach(element => {
      element.value = false;
    });
    this.setState({ colunasAgendamentoPendentes: colunms });
  };
  /* CONFIRMACAO PENDENTE - End */

  /* CHECKBOX PEDIDO - End */

  /* SEARCH PEDIDO TODOS PEDIDOS - Begin */

  /* TODOS PEDIDOS - Begin */
  handlerClearSearchFieldTodosPedidos = () => {
    this.setState({ searchFieldTodosPedidos: "" });
  };

  handleChangeSearchFieldPedidoTodosPedidos = (event) => {
    event.persist();
    this.setState({ searchFieldTodosPedidos: event.target.value });
  };

  handleChangeSearchFieldExternalPedidoTodosPedidos = (event) => {
    event.persist();
    this.setState({ searchFieldExternalTodosPedidos: event.target.value });
  };
  /* TODOS PEDIDOS - End */

  /* CONFIRMACAO PENDENTE - Begin */
  handlerClearSearchFieldAgendamentoPendentes = () => {
    this.setState({ searchFieldAgendamentoPendentes: "" });
  };

  handleChangeSearchFieldPedidoAgendamentoPendentes = (event) => {
    event.persist();
    this.setState({ searchFieldAgendamentoPendentes: event.target.value });
  };
  /* CONFIRMACAO PENDENTE - End */

  /* SEARCH PEDIDO TODOS PEDIDOS - End */

  /* BUTTONS MODAL - Begin */

  /* TODOS PEDIDOS - Begin */

  handlerAplicarFiltersTodosPedidos = async () => {
    await this.setState({ isLoading: true, pageInitialTodosPedidos: 0 });
    await this.loadTodosPedidos({
      linha_inicial: 0,
      qtd_registro: this.state.pageRowsTodosPedidos,
      tipo_load: "applyFilters"
    });
    await this.setState({ isLoading: false });

    TagManager.dataLayer({
      dataLayer: {
        event: 'event',
        eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
        eventAction: 'clique:botao',
        eventLabel: `aplicar-filtros-todos-pedidos`,
      }
    });
  };

  handlerCallCleanTodosPedidos = async () => {
    await this.handlerClearAllFilterTagTodosPedidos();
    await this.handlerClearSearchFieldTodosPedidos();
    await this.handlerClearCheckboxTodosPedidos();
    await this.handlerClearAllDateTodosPedidos();
    await this.handlerClearRadioEscolhaDataTodosPedidos();
    await this.handlerClearEscolhaFilialTodosPedidos();
    await this.handlerClearEscolhaCondicaoTodosPedidos();
  };

  handlerCleanFiltersTodosPedidos = async () => {
    await this.setState({
      isLoading: true,
      firstLoad: true
    });
    await this.handlerCallCleanTodosPedidos();

    await this.setState({
      searchFieldTodosPedidos: "",
      searchFieldExternalTodosPedidos: "",
      escolhaDataTodosPedidos: "dtEmissao",
      dtInitialTodosPedidos: moment().toDate(),
      dtEndTodosPedidos: moment().add(30, 'days').toDate(),
      escolhaFilialTodosPedidos: { id: 0, name: "Selecione uma filial" },
    });
    await this.loadTodosPedidos({
      linha_inicial: 0,
      qtd_registro: this.state.pageRowsTodosPedidos,
      tipo_load: "applyFilters"
    });
    await this.setState({
      isLoading: false,
      firstLoad: false
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'event',
        eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
        eventAction: 'clique:botao',
        eventLabel: `limpar-filtros-todos-pedidos`,
      }
    });
  };

  /* TODOS PEDIDOS - End */

  /* CONFIRMACAO PENDENTE - Begin */

  handlerAplicarFiltersAgendamentoPendentes = async () => {
    await this.setState({
      isLoading: true,
      firstLoad: true
    });
    this.loadAgendamentoPendentes({
      linhaInicial: 0,
      qtdRegistro: this.state.pageRowsAgendamentoPendentes,
      tipo_load: "applyFilters"
    });
    await this.setState({
      isLoading: false,
      firstLoad: false
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'event',
        eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
        eventAction: 'clique:botao',
        eventLabel: `aplicar-filtros-confirmacao-pendente`,
      }
    });
  };

  handlerJustCleanFiltersAgendamentosPendentes = async () => {
    // this.handlerClearAllFilterTagAgendamentoPendentes();
    this.handlerClearSearchFieldAgendamentoPendentes();
    this.handlerClearCheckboxAgendamentoPendentes();

    await this.setState({
      searchFieldAgendamentoPendentes: "",
      searchFieldExternalAgendamentoPendentes: "",
      escolhaDataAgendamentoPendentes: "dtEmissao",
      dtInitialAgendamentoPendentes: moment().toDate(),
      dtEndAgendamentoPendentes: moment().add(30, 'days').toDate(),
      escolhaFilialAgendamentoPendentes: { id: 0, name: "Selecione uma filial" },
    });
  };

  handlerCleanFiltersAgendamentoPendentes = async () => {
    await this.setState({
      isLoading: true,
      firstLoad: true
    });

    this.handlerClearAllFilterTagAgendamentoPendentes();
    this.handlerJustCleanFiltersAgendamentosPendentes();

    await this.loadAgendamentoPendentes({
      linhaInicial: 0,
      qtdRegistro: this.state.pageRowsAgendamentoPendentes,
      tipo_load: "applyFilters"
    });
    await this.setState({
      isLoading: false,
      firstLoad: false
    });
    TagManager.dataLayer({
      dataLayer: {
        event: 'event',
        eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
        eventAction: 'clique:botao',
        eventLabel: `limpar-filtros-confirmacao-pendente`,
      }
    });
  };

  /* CONFIRMACAO PENDENTE - End */

  /* BUTTONS MODAL - End */

  /* OPCOES BUSCA - End */

  /* OPCOES BUSCA TAGS - Begin */

  /* TODOS PEDIDOS - Begin */

  handlerClearAllFilterTagTodosPedidos = () => {
    this.state.colunasFilterTagsTodosPedidos.forEach((element, i) => {
      this.handlerClearFilterTagTodosPedidos(i, false);
    });
  };

  handlerClearFilterTagsButKeepDates = () => { // SOUR 1407
    this.state.colunasFilterTagsTodosPedidos.forEach((element, i) => {
      if (element.key !== 'Data de emissão') {
        this.handlerClearFilterTagTodosPedidos(i, false);
      }
    });
  };

  handlerClearFilterTagTodosPedidos = (i, all) => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;
    if (newColunasFilterTags[i] == null) return;
    newColunasFilterTags[i].value = newColunasFilterTags[i].origemValue;
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });

    if (all === true) {
      this.handlerAplicarFiltersTodosPedidos();
    }

    const index = this.state.colunasTodosPedidos.map((e) => { return e.key }).indexOf(newColunasFilterTags[i].key);
    if (index < 0) return;
    let colunms = this.state.colunasTodosPedidos;
    colunms[index].value = !(this.state.colunasTodosPedidos[index].value);
    this.setState({ colunasTodosPedidos: colunms });
  };

  handlerLoadSearchFilterTagTodosPedidos = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;
    for (let i = 0; i < this.state.colunasTodosPedidos.length; i++) {
      newColunasFilterTags.push({
        key: this.state.colunasTodosPedidos[i].key,
        value: this.state.searchFieldTodosPedidos,
        origemValue: ""
      });
    }
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });
  };

  handlerChangeSearchFilterTagTodosPedidos = (i) => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;

    const nameObject = this.state.colunasTodosPedidos[i].key;
    const indexObject = this.state.colunasFilterTagsTodosPedidos.map(e => e.key).indexOf(nameObject);

    if (indexObject < 0) return;

    if (this.state.colunasTodosPedidos[i].value)
      newColunasFilterTags[indexObject].value = this.state.searchFieldTodosPedidos;
    else
      newColunasFilterTags[indexObject].value = "";
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });
  };

  /* TODOS PEDIDOS - End */

  /* CONFIRMACAO PENDENTE - Begin */

  handlerClearAllFilterTagAgendamentoPendentes = () => {
    this.state.colunasFilterTagsAgendamentoPendentes.forEach((element, i) => {
      this.handlerClearFilterTagAgendamentoPendentes(i, false);
    });
  };

  handlerClearFilterTagAgendamentoPendentes = (i, all) => {
    let newColunasFilterTags = this.state.colunasFilterTagsAgendamentoPendentes;
    if (newColunasFilterTags[i] == null) {
      return;
    }
    newColunasFilterTags[i].value = newColunasFilterTags[i].origemValue;

    if (all === true) {
      this.handlerAplicarFiltersAgendamentoPendentes();
    }

    const index = this.state.colunasAgendamentoPendentes.map((e) => { return e.key }).indexOf(newColunasFilterTags[i].key);
    if (index < 0) return;
    let colunms = this.state.colunasAgendamentoPendentes;
    colunms[index].value = !(this.state.colunasAgendamentoPendentes[index].value);
    this.setState({
      colunasAgendamentoPendentes: colunms
    });
    this.handlerAplicarFiltersAgendamentoPendentes();
  };

  handlerLoadSearchFilterTagAgendamentoPendentes = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsAgendamentoPendentes;
    for (let i = 0; i < this.state.colunasAgendamentoPendentes.length; i++) {
      newColunasFilterTags.push({
        key: this.state.colunasAgendamentoPendentes[i].key,
        value: this.state.searchFieldAgendamentoPendentes,
        origemValue: ""
      });
    }
    this.setState({ colunasFilterTagsAgendamentoPendentes: newColunasFilterTags });
  };

  handlerChangeSearchFilterTagAgendamentoPendentes = (i) => {
    let newColunasFilterTags = this.state.colunasFilterTagsAgendamentoPendentes;

    const nameObject = this.state.colunasAgendamentoPendentes[i].key;
    const indexObject = this.state.colunasFilterTagsAgendamentoPendentes.map(e => e.key).indexOf(nameObject);

    if (indexObject < 0) return;

    if (this.state.colunasAgendamentoPendentes[i].value)
      newColunasFilterTags[indexObject].value = this.state.searchFieldAgendamentoPendentes;
    else
      newColunasFilterTags[indexObject].value = "";

    return this.setState({ colunasFilterTagsAgendamentoPendentes: newColunasFilterTags });
  };

  /* CONFIRMACAO PENDENTE - End */

  /* OPCOES BUSCA TAGS - End */

  /* CALENDAR - Begin */

  /* TODOS PEDIDOS - Begin */
  handlerDataSetTagTodosPedidos = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;

    let rbData = "agendamento";
    if (this.state.escolhaDataTodosPedidos === "dtEmissao") {
      rbData = "emissão";
    };

    const indexObject = this.state.colunasFilterTagsTodosPedidos
      .map(e => e.key)
      .indexOf(`Data de ${rbData}`);

    if (indexObject < 0) return;

    newColunasFilterTags[indexObject].value = `${this.dateFormat(this.state.dtInitialTodosPedidos)} - ${this.dateFormat(this.state.dtEndTodosPedidos)}`;
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });
  };

  handlerChangeDateInitialTodosPedidos = async (value) => {
    await this.setState({ dtInitialTodosPedidos: value });
    this.handlerDataSetTagTodosPedidos();
  };

  handlerChangeDateEndTodosPedidos = async (value) => {
    await this.setState({ dtEndTodosPedidos: value });
    this.handlerDataSetTagTodosPedidos();
  };

  handlerClearAllDateTodosPedidos = () => {
    this.setState({
      dtInitialTodosPedidos: moment().toDate(),
      dtEndTodosPedidos: moment().add(30, 'days').toDate(),
    });
  };
  /* TODOS PEDIDOS - End */

  /* AGENDAMENTOS PENDENTES - Begin */
  handlerDataSetTagAgendamentoPendentes = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsAgendamentoPendentes;

    newColunasFilterTags[0].value = `${this.dateFormat(this.state.dtInitialAgendamentoPendentes)} - ${this.dateFormat(this.state.dtEndAgendamentoPendentes)}`;

    this.setState({ colunasFilterTagsAgendamentoPendentes: newColunasFilterTags });
  };

  handlerChangeDateInitialAgendamentoPendentes = async (value) => {
    await this.setState({ dtInitialAgendamentoPendentes: value });
    this.handlerDataSetTagAgendamentoPendentes();
  };

  handlerChangeDateEndAgendamentoPendentes = async (value) => {
    await this.setState({ dtEndAgendamentoPendentes: value });
    this.handlerDataSetTagAgendamentoPendentes();
  };
  /* AGENDAMENTOS PENDENTES - End */

  /* CALENDAR - End */

  /* ESCOLHA DATA - Begin */

  /* TODOS PEDIDOS - Begin */
  handlerEscolhaDataSetTagTodosPedidos = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;
    let rbData = "agendamento";

    if (this.state.escolhaDataTodosPedidos === "dtEmissao") {
      rbData = "emissão";
    };

    const indexObjectAgendamento = this.state.colunasFilterTagsTodosPedidos
      .map(e => e.key)
      .indexOf(`Data de agendamento`);

    const indexObjectEmissao = this.state.colunasFilterTagsTodosPedidos
      .map(e => e.key)
      .indexOf(`Data de emissão`);

    if (indexObjectAgendamento < 0 && indexObjectEmissao < 0) return;

    let indexObject = indexObjectAgendamento;
    if (indexObjectEmissao > -1) indexObject = indexObjectEmissao;

    newColunasFilterTags[indexObject].key = `Data de ${rbData}`;
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });
  };

  handlerChangeRadioEscolhaDataTodosPedidos = async (value) => {
    await this.setState({ escolhaDataTodosPedidos: value });
    this.handlerEscolhaDataSetTagTodosPedidos();
  };

  handlerClearRadioEscolhaDataTodosPedidos = () => {
    this.setState({ escolhaDataTodosPedidos: "dtEmissao" });
  };
  /* TODOS PEDIDOS - End */

  /* ESCOLHA DATA - End */

  /* ESCOLHA FILIAL - Begin */

  /* TODOS PEDIDOS - Begin */
  handlerEscolhaFilialSetTagTodosPedidos = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;

    const indexObject = this.state.colunasFilterTagsTodosPedidos
      .map(e => e.key)
      .indexOf("Filial");
    if (indexObject < 0) return;

    if (this.state.escolhaFilialTodosPedidos.id > 0)
      newColunasFilterTags[indexObject].value = this.state.escolhaFilialTodosPedidos.id;
    else
      newColunasFilterTags[indexObject].value = "";
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });
  };

  handlerChangeEscolhaFilialTodosPedidos = async (value) => {
    await this.setState({ escolhaFilialTodosPedidos: value });
    this.handlerEscolhaFilialSetTagTodosPedidos();
  };

  handlerClearEscolhaFilialTodosPedidos = (value) => {
    this.setState({ escolhaFilialTodosPedidos: this.state.opcoesFilial[0] });
  };
  /* TODOS PEDIDOS - End */

  /* CONDICAO - Begin */
  handlerEscolhaCondicaoSetTagTodosPedidos = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsTodosPedidos;

    const indexObject = this.state.colunasFilterTagsTodosPedidos
      .map(e => e.key)
      .indexOf("Condição");
    if (indexObject < 0) return;

    if (this.state.escolhaCondicaoTodosPedidos.id > 0)
      newColunasFilterTags[indexObject].value = this.state.escolhaCondicaoTodosPedidos.id;
    else
      newColunasFilterTags[indexObject].value = "";
    this.setState({ colunasFilterTagsTodosPedidos: newColunasFilterTags });
  };

  handlerChangeEscolhaCondicaoTodosPedidos = async (value) => {
    await this.setState({ escolhaCondicaoTodosPedidos: value });
    this.handlerEscolhaCondicaoSetTagTodosPedidos();
  };

  handlerClearEscolhaCondicaoTodosPedidos = (value) => {
    this.setState({ escolhaCondicaoTodosPedidos: this.state.opcoesCondicao[0] });
  };
  /* CONDICAO - End */

  /* CONFIRMACAO PENDENTE - Begin */
  handlerEscolhaFilialSetTagAgendamentoPendentes = () => {
    let newColunasFilterTags = this.state.colunasFilterTagsAgendamentoPendentes;

    const indexObject = this.state.colunasFilterTagsAgendamentoPendentes
      .map(e => e.key)
      .indexOf("Filial");
    if (indexObject < 0) return;

    if (this.state.escolhaFilialAgendamentoPendentes.id > 0)
      newColunasFilterTags[indexObject].value = this.state.escolhaFilialAgendamentoPendentes.id;
    else
      newColunasFilterTags[indexObject].value = "";

    this.setState({ colunasFilterTagsAgendamentoPendentes: newColunasFilterTags });
  };

  handlerChangeEscolhaFilialAgendamentoPendentes = async (value) => {
    await this.setState({ escolhaFilialAgendamentoPendentes: value });
    this.handlerEscolhaFilialSetTagAgendamentoPendentes();
  };
  /* CONFIRMACAO PENDENTE - End */

  /* ESCOLHA FILIAL - End */

  /* FILTRO PEDIDOS - Begin */

  /* TODOS PEDIDOS - Begin */
  handlerFiltroPedidos = async (radioValue) => {
    await this.setState({ opcoesFiltroPedidosValue: radioValue });
    await this.setState({ isLoading: true });
    await this.loadTodosPedidos({
      linha_inicial: 0,
      qtd_registro: this.state.pageRowsTodosPedidos,
      tipo_load: "filterStatus"
    });
    await this.setState({ isLoading: false });
  };
  /* TODOS PEDIDOS - End */

  /* FILTRO PEDIDOS - End */

  /* DATA CONFIRMACAO PENDENTE - Begin */

  /* CONFIRMACAO PENDENTE - End */
  handlerCheckboxAllAgendamentoPendentes = async (event) => {
    if (this.state.dataAgendamentoPendentesSelected.length == this.state.qtdAgendamentoPendentes) {
      this.setState({
        dataAgendamentoPendentesSelected: []
      });
    } else {
      await this.loadAgendamentoPendentes({
        linhaInicial: 0,
        qtdRegistro: this.state.qtdAgendamentoPendentes,
        tipo_load: ""
      });
      await this.setState({
        dataAgendamentoPendentesSelected: this.state.dataAgendamentoPendentes
      });
      await this.loadAgendamentoPendentes({
        linhaInicial: this.state.pageInitialAgendamentoPendentes,
        qtdRegistro: this.state.pageRowsAgendamentoPendentes,
        tipo_load: ""
      });
      this.setState({ isLoading: false });
    }
  };

  handlerSelectCheckboxAgendamentoPendentes = (params) => {
    let newArray = this.state.dataAgendamentoPendentesSelected;
    const index = newArray
      .map(e => md5(e.nr_pedido.toString() + e.dt_agendamento))
      .indexOf(md5(params.nr_pedido.toString() + params.dt_agendamento));
    if (index > -1) {
      newArray.splice(index, 1);
    } else {
      newArray.push(params);
    }
    this.setState({ dataAgendamentoPendentesSelected: newArray });
  };
  /* CONFIRMACAO PENDENTE - End */

  /* DATA CONFIRMACAO PENDENTE - End */

  /* PAGINATION - Begin */

  /* CONFIRMACAO PENDENTE - End */
  handlerOnChangeAgendamentoPendentes = async (pageFrom) => {
    await this.setState({ isLoading: true });
    await this.loadAgendamentoPendentes({
      linhaInicial: pageFrom,
      qtdRegistro: this.state.pageRowsAgendamentoPendentes,
      tipo_load: "pageFrom"
    });
    this.setState({
      pageInitialAgendamentoPendentes: pageFrom,
      isLoading: false
    });
  };

  changePageModalAgendamentoPendentes = async (page, sortOrder) => {
    await this.setState({ isLoading: true, itensTableAgendamentoPendentes: [["Carregando dados..."]] });
    const element = this.state.lastPedidoSelectedAgendamentoPendentes;
    const dtAgenda = element.scheduleDate;
    this.loadDataModalAgendamentoPendentes({
      cdFil: element.branchDeliveryId,
      nrPc: element.purchaseOrderId,
      dtAgenda,
      inStatus: 'P',
      linhaInicial: page * this.state.rowsPerPageModalAgendamentoPendentes,
      qtdRegistro: this.state.rowsPerPageModalAgendamentoPendentes,
    });
    let total = 0;
    if (this.state.itensTableAgendamentoPendentes.length > 0) {
      total = parseInt(this.state.itensTableAgendamentoPendentes[0].totalRows);
    }
    this.setState({
      isLoading: false,
      pageModalAgendamentoPendentes: page,
      countModalAgendamentoPendentes: total,
    });
  };
  /* CONFIRMACAO PENDENTE - End */

  /* TODOS PEDIDOS - Begin */
  handlerSelectedTransferTodosPedidos = async () => {
    let array = [];
    this.state.dataTodosPedidos.forEach((y, i) => {
      this.state.dataTodosPedidosSelected.forEach(x => {
        if (JSON.stringify(y) === JSON.stringify(x)) {
          array.push(i);
        }
      });
    });
    await this.setState({ dataTodosPedidosIndexSelected: array });
  };

  handlerChangePageTodosPedidos = async (page, sortOrder) => {
    await this.setState({ isLoading: true, dataTodosPedidos: [["Carregando dados..."]] });
    await this.loadTodosPedidos({
      linha_inicial: page * this.state.pageRowsTodosPedidos,
      qtd_registro: this.state.pageRowsTodosPedidos,
      tipo_load: "changePage"
    });
    await this.setState({
      isLoading: false,
      pageInitialTodosPedidos: page,
      dataTodosPedidosIndexSelected: []
    });
    await this.handlerSelectedTransferTodosPedidos();
  };

  handlerChangeRowsPerPageTodosPedidos = async (numberOfRows) => {
    await this.setState({
      isLoading: true,
      dataTodosPedidos: [["Carregando dados..."]],
      pageRowsTodosPedidos: numberOfRows
    });
    await this.loadTodosPedidos({
      linha_inicial: this.state.pageInitialTodosPedidos * this.state.pageRowsTodosPedidos,
      qtd_registro: numberOfRows,
      tipo_load: "rowsPerPage"
    });
    await this.setState({
      isLoading: false,
      dataTodosPedidosIndexSelected: []
    });
    await this.handlerSelectedTransferTodosPedidos();
  };
  /* TODOS PEDIDOS - End */

  /* PAGINATION - End */

  /* MODAL DETALHES DO PEDIDO - Begin */

  /* CONFIRMACAO PENDENTE - End */

  handleDialogModalTableAgendamentoPendentes = () => {
    this.setState({
      itensTableSelectedAgendamentoPendentes: [],
      isOpenModalTableAgendamentoPendentes: !this.state.isOpenModalTableAgendamentoPendentes
    });
  };

  handleModalRecusaAgendamentoPendentes = () => {
    this.handlerOpenDataSugestaoAgendamentoPendetes(true);
  };

  handleModalConfirmarAgendamentoPendentes = () => {
    this.setState({
      openModalConfirmarAgendamentoPendentes: !this.state.openModalConfirmarAgendamentoPendentes
    });
  };

  handleModalConfirmarSelecionadosAgendamentoPendentes = async () => {
    this.setState({ isLoading: true });
    const element = this.state.lastPedidoSelectedAgendamentoPendentes;
    const dtAgenda = element.scheduleDate;
    if (this.state.lastPedidoSelectedAgendamentoPendentes == null) {
      const orders = [];
      this.state.itensTableSelectedAgendamentoPendentes.every(async (elementProd) => {
        orders.push({
          cdFil: element.branchId,
          nrPc: element.purchaseOrderId,
          IdProd: elementProd.productId,
          dtEntrega: elementProd.deliveryDate,
          dtAgenda: dtAgenda,
          inStatus: "C",
          idMotivoRecusa: null,
          dtAgeSugFornec: null
        });
      });
      await this.loadConfirmRefuseByList(orders);
    } else {
      const element = this.state.lastPedidoSelectedAgendamentoPendentes;
      const dtAgenda = element.scheduleDate;
      if (this.state.itensTableSelectedAgendamentoPendentes.length == 0) {
        const checkRequest = await this.loadConfirmRefuse({
          cdFil: element.branchId,
          nrPc: element.purchaseOrderId,
          IdProd: element.productId,
          dtAgenda: dtAgenda,
          inStatus: "C",
          idMotivoRecusa: null,
          dtAgeSugFornec: null,
        });

        TagManager.dataLayer({
          dataLayer: {
            event: 'event',
            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
            eventAction: 'clique:botao',
            eventLabel: `confirmacao-pedido-${element.purchaseOrderId}`,
          }
        });

        if (checkRequest) {
          this.handleDialogModalTableAgendamentoPendentes();
          this.handleModalConfirmarAgendamentoPendentes();
          await this.handlerDataLoad();
        }
      } else {
        let checkResult = true;
        const orders = [];
        this.state.itensTableSelectedAgendamentoPendentes.every(async (elementProd) => {
          orders.push({
            cdFil: element.branchId,
            nrPc: element.purchaseOrderId,
            IdProd: elementProd.productId,
            dtEntrega: elementProd.deliveryDate,
            dtAgenda: dtAgenda,
            inStatus: "C",
            idMotivoRecusa: null,
            dtAgeSugFornec: null,
          });

          TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
              eventAction: 'clique:botao',
              eventLabel: `confirmacao-pedido-${element.purchaseOrderId}`,
            }
          });

        });

        const checkRequest = await this.loadConfirmRefuseByList(orders);

        if (!checkRequest) {
          checkResult = checkRequest
          return;
        }

        if (checkResult) {
          this.handleDialogModalTableAgendamentoPendentes();
          this.handleModalConfirmarAgendamentoPendentes();
          await this.handlerDataLoad();
        }
      }
    }

    TagManager.dataLayer({
      dataLayer: {
        event: 'event',
        eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
        eventAction: 'clique:botao',
        eventLabel: `confirma-pedido-${element.purchaseOrderId}`,
      }
    });

    await this.setState({ isLoading: false });
  };
  /* CONFIRMACAO PENDENTE - End */

  /* MODAL DETALHES DO PEDIDO - End */

  /* MODAL RECUSA AGENDAMENTO PENDENTE - Begin */
  handleModalRecusaOpenAgendamentoPendentes = () => {
    this.setState({ openModalRecusaAgendamentoPendentes: true });
  };

  handleModalRecusaCloseAgendamentoPendentes = () => {
    this.setState({ openModalRecusaAgendamentoPendentes: false });
  };

  handlerChangeRowsPerPageAgendamentoPendentes = async (value) => {
    this.setState({
      pageRowsAgendamentoPendentes: value,
      isLoading: true
    });
    await this.loadAgendamentoPendentes({
      linhaInicial: 0,
      qtdRegistro: value,
      tipo_load: "rowsPerPage"
    });
    this.setState({ isLoading: false });
  };
  /* MODAL RECUSA AGENDAMENTO PENDENTE - End */

  /* MODAL CONFIRMAR AGENDAMENTO PENDENTE - Begin */
  handleModalConfirmarOpenAgendamentoPendentes = () => {
    this.setState({ openModalConfirmarAgendamentoPendentes: true });
  };

  handleModalConfirmarCloseAgendamentoPendentes = () => {
    this.setState({ openModalConfirmarAgendamentoPendentes: false });
  };

  handleImprimirAgendamentoPendentes = () => {

  };
  /* MODAL CONFIRMAR AGENDAMENTO PENDENTE - End */

  /* MODAL MOTIVO RECUSA AGENDAMENTO PENDENTE - Begin */
  handleModalMotivoRecusaOpenAgendamentoPendentes = () => {
    this.setState({ openModalMotivoRecusaAgendamentoPendentes: true });
  };

  handleModalMotivoRecusaCloseAgendamentoPendentes = () => {
    this.setState({ openModalMotivoRecusaAgendamentoPendentes: false });
  };

  handleModalMotivoRecusaChangeAgendamentoPendentes = (value, checked) => {
    this.setState({ escolhaMotivoRecusaAgendamentoPendentes: parseInt(value) });
  };

  handleModalMotivoRecusaConfirmAgendamentoPendentes = async (event) => {
    this.setState({ isLoading: true });
    if (this.state.lastPedidoSelectedAgendamentoPendentes == null) {
      let checkResult = true;
      const orders = [];
      this.state.dataAgendamentoPendentesSelected.every(async (element) => {
        orders.push({
          cdFil: element.cd_filial,
          nrPc: element.nr_pedido,
          IdProd: null,
          dtAgenda: element.dt_agendamento,
          inStatus: "R",
          idMotivoRecusa: this.state.escolhaMotivoRecusaAgendamentoPendentes,
          dtAgeSugFornec: this.state.dataSugestaoEntrega,
        })

        TagManager.dataLayer({
          dataLayer: {
            event: 'event',
            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
            eventAction: 'clique:botao',
            eventLabel: `recusa-pedido-${element.nr_pedido}`,
          }
        });
      });

      const checkRequest = await this.loadConfirmRefuseByList(orders);

      if (!checkRequest) {
        checkResult = checkRequest
        return;
      }
      if (checkResult) {
        this.handleModalRecusaOpenAgendamentoPendentes();
        this.handleModalMotivoRecusaCloseAgendamentoPendentes();
        await this.handlerDataLoad();
      }
    } else {
      const element = this.state.lastPedidoSelectedAgendamentoPendentes;
      const dtAgenda = element.scheduleDate;
      if (this.state.itensTableSelectedAgendamentoPendentes.length == 0) {
        const checkRequest = await this.loadConfirmRefuse({
          cdFil: element.branchId,
          nrPc: element.purchaseOrderId,
          IdProd: null,
          dtAgenda: dtAgenda,
          inStatus: "R",
          idMotivoRecusa: this.state.escolhaMotivoRecusaAgendamentoPendentes,
          dtAgeSugFornec: this.state.dataSugestaoEntrega,
        });

        TagManager.dataLayer({
          dataLayer: {
            event: 'event',
            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
            eventAction: 'clique:botao',
            eventLabel: `recusa-pedido-${element.purchaseOrderId}`,
          }
        });

        if (checkRequest) {
          this.handleDialogModalTableAgendamentoPendentes();
          this.handleModalMotivoRecusaCloseAgendamentoPendentes();
          this.handleModalRecusaOpenAgendamentoPendentes();
          await this.handlerDataLoad();
        }
      } else {
        const orders = [];
        this.state.itensTableSelectedAgendamentoPendentes.every(async (elementProd) => {
          orders.push({
            cdFil: element.branchId,
            nrPc: element.purchaseOrderId,
            IdProd: elementProd.productId,
            dtEntrega: elementProd.deliveryDate,
            dtAgenda: dtAgenda,
            inStatus: "R",
            idMotivoRecusa: this.state.escolhaMotivoRecusaAgendamentoPendentes,
            dtAgeSugFornec: this.state.dataSugestaoEntrega,
          });
        });

        const checkRequest = await this.loadConfirmRefuseByList(orders);

        if (!checkRequest) {
          return;
        }

        TagManager.dataLayer({
          dataLayer: {
            event: 'event',
            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
            eventAction: 'clique:botao',
            eventLabel: `recusa-pedido-${element.purchaseOrderId}`,
          }
        });

        if (checkRequest) {
          this.handleDialogModalTableAgendamentoPendentes();
          this.handleModalMotivoRecusaCloseAgendamentoPendentes();
          this.handleModalRecusaOpenAgendamentoPendentes();
          await this.handlerDataLoad();
        }
      }

    }
    this.setState({
      isLoading: false,
      escolhaMotivoRecusaAgendamentoPendentes: "",
      dataSugestaoEntrega: new Date(),
    });
  };

  onRowsSelectAgendamentoPendetes = (value) => {
    let newItensTableSelectedAgendamentoPendentes = this.state.itensTableSelectedAgendamentoPendentes;

    newItensTableSelectedAgendamentoPendentes.map(item => {
      delete item.CONFIRM_AGENDAMENTO;
      return item;
    })

    const index = newItensTableSelectedAgendamentoPendentes
      .findIndex(item => JSON.stringify(item) === JSON.stringify(value))

    if (index > -1) {
      newItensTableSelectedAgendamentoPendentes.splice(index, 1);
    } else {
      newItensTableSelectedAgendamentoPendentes.push(value);
    }

    this.setState({
      itensTableSelectedAgendamentoPendentes: newItensTableSelectedAgendamentoPendentes
    });
  };

  onAllRowsSelectAgendamentoPendetes = async () => {
    if (this.state.itensTableSelectedAgendamentoPendentes.length == this.state.countModalAgendamentoPendentes) {
      await this.setState({
        itensTableSelectedAgendamentoPendentes: []
      });
    } else {

      const e = this.state.lastPedidoSelectedAgendamentoPendentes;
      const dtAgenda = e.scheduleDate;

      // joga todos pro array selected
      await this.loadDataModalAgendamentoPendentes({
        cdFil: e.branchDeliveryId,
        nrPc: e.purchaseOrderId,
        dtAgenda,
        inStatus: 'P',
        linhaInicial: 0,
        qtdRegistro: this.state.countModalAgendamentoPendentes,
      });

      // necessário para criar cópia, se passar direto ele cria referência
      const copy = JSON.parse(JSON.stringify(this.state.itensTableAgendamentoPendentes));
      await this.setState({
        itensTableSelectedAgendamentoPendentes: copy
      });

      // volta ao que estava anteriormente
      await this.loadDataModalAgendamentoPendentes({
        cdFil: e.branchDeliveryId,
        nrPc: e.purchaseOrderId,
        dtAgenda,
        inStatus: 'P',
        linhaInicial: 0,
        qtdRegistro: this.state.rowsPerPageModalAgendamentoPendentes,
      });
    }
  };
  /* MODAL MOTIVO RECUSA AGENDAMENTO PENDENTE - End */

  /* MODAL CALENDÁRIO SEGUESTÃO DATA DE ENTREGA AGENDAMENTO PENDENTE - Begin */
  handlerOnChangeDataSugestaoEntregaAgendamentoPendetes = (value) => {
    this.setState({ dataSugestaoEntrega: value });
  };

  getDataSugestaoEntregaAgendamentoConfirmado = () => {
    return this.state.dataSugestaoEntrega;
  };

  handlerOpenDataSugestaoAgendamentoPendetes = (value) => {
    this.setState({
      openDialogCalendarAgendamentoPendentes: value
    });
  };

  handlerConfirmarDataSugestaoAgendamentoPendetes = () => {
    this.handlerOpenDataSugestaoAgendamentoPendetes(false);
    this.handleModalMotivoRecusaOpenAgendamentoPendentes();
  };
  /* MODAL CALENDÁRIO SEGUESTÃO DATA DE ENTREGA AGENDAMENTO PENDENTE - End */

  /* ACTIONS - Begin */
  /* TODOS PEDIDOS - Begin */
  handlerBaixarEtiquetaTodosPedidos = async () => {};

  handlerAlterarOpcaoPagTodosPedidos = async () => {
    await this.handlerModalItensNovaOpcaoOpenTodosPedidos();
  };

  handlerOpcoesRecebimentoTodosPedidos = async (element) => {
    this.setState({ lastPedidoSelectedTodosPedidos: element });
    this.handlerModalItensNovaOpcaoOpenTodosPedidos();
  };
  /* TODOS PEDIDOS - End */

  /* CONFIRMACAO PENDENTE - Begin */
  handlerConfirmarTodosSelecionadosAgendamentoPendentes = async () => {
    await this.setState({ isLoading: true });
    let checkResult = true;
    const orders = [];
    await this.state.dataAgendamentoPendentesSelected.every(async (element) => {
      orders.push({
        cdFil: element.cd_filial,
        nrPc: element.nr_pedido,
        IdProd: null,
        dtAgenda: element.dt_agendamento,
        inStatus: "C",
        idMotivoRecusa: null,
        dtAgeSugFornec: null,
      })

      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
          eventAction: 'clique:botao',
          eventLabel: `confirma-pedido-${element.nr_pedido}`,
        }
      });
    });

    const checkRequest = await this.loadConfirmRefuseByList(orders);

    if (!checkRequest) {
      checkResult = checkRequest;
      return;
    }

    if (checkResult) {
      this.handleModalConfirmarAgendamentoPendentes();
      this.setState({ isLoading: false });
      await this.handlerDataLoad();

    }

  };

  handlerRecusarTodosSelecionadosAgendamentoPendentes = () => {
    this.handlerOpenDataSugestaoAgendamentoPendetes(true);
    this.setState({ lastPedidoSelectedAgendamentoPendentes: null });
  };

  onColumnUpdateTodosPedidos(colunas) {
    this.setState({ columnsTodosPedidos: colunas });
  };
  /* CONFIRMACAO PENDENTE - End */
  /* ACTIONS - End */

  /* Modal nova opcao de todos pedidos - Begin*/
  handlerModalNovaOpcaoOpenTodosPedidos = () => {
    this.setState({ openModalNovaOpcaoTodosPedidos: true });
  };

  handlerModalNovaOpcaoCloseTodosPedidos = () => {
    this.setState({ openModalNovaOpcaoTodosPedidos: false });
  };

  handlerModalNovaOpcaoEntendidoTodosPedidos = () => {
    this.handlerModalNovaOpcaoCloseTodosPedidos();
  };
  /* Modal nova opcao de todos pedidos - End*/

  /* Modal opcoes recebimento - Begin*/
  handlerModalItensNovaOpcaoOpenTodosPedidos = () => {
    this.setState({ openModalItensNovaOpcaoTodosPedidos: true });
  };

  handlerModalItensNovaOpcaoCloseTodosPedidos = () => {
    this.setState({ openModalItensNovaOpcaoTodosPedidos: false });
  };

  handlerModalItensNovaOpcaoChangeTodosPedidos = (value, checked) => {
    this.setState({ escolhaModalItensNovaOpcaoTodosPedidos: parseInt(value) });
  };

  handlerModalItensNovaOpcaoAplicarAlteracoesTodosPedidos = async () => {
    await this.setState({ isLoading: true });
    await this.handlerModalItensNovaOpcaoCloseTodosPedidos();

    if (this.state.lastPedidoSelectedTodosPedidos != null) {
      const element = this.state.lastPedidoSelectedTodosPedidos;
      const checkRequest = await this.loadAtualizaOpcaoPagmento(element);

      if (checkRequest) {
        await this.handlerModalNovaOpcaoOpenTodosPedidos();
        await this.handlerDataLoad();
      }
    } else {
      let checkResult = true;
      await this.state.dataTodosPedidosSelected.every(async (element) => {
        const checkRequest = await this.loadAtualizaOpcaoPagmento(element);

        if (!checkRequest) {
          checkResult = checkRequest;
          return;
        }
      });

      if (checkResult) {
        await this.setState({ dataTodosPedidosSelected: [] });
        await this.handlerModalNovaOpcaoOpenTodosPedidos();
        await this.handlerDataLoad();
      }
    }

    await this.setState({
      escolhaModalItensNovaOpcaoTodosPedidos: "",
      isLoading: false
    });
  };
  /* Modal opcoes recebimento - End*/

  dateParse = (date) => {
    return moment(date, "DD/MM/YYYY").toDate();
  };

  dateFormat = (date) => {
    return moment(date).format('DD/MM/YYYY');
  };

  handlerChangeRowsPerPagePedidoProtocolo = async (value) => {
    await this.setState({ rowsPerPagePedidoProtocolo: value });
  };

  handlerChangeTotalRowsPedidoProtocolo = async (value) => {
    await this.setState({ totalRowsPedidoProtocolo: value });
  };
  //Essa função é ativada somente qnd o usuário clica no Botão de Download da Etiqueta
  shapeEtiquetasObject = () => {
    const data = this.state.dataTodosPedidosSelectedEtiquetas
      .map((item) => parseInt(item.id_prod));

    const unique_id_prods = [...new Set(data)];

    return unique_id_prods;
  }

  handleToggleCheckboxEtiquetasTodosPedidos = (rowData) => {
    const produto = this.shapeDataTodosPedidosSelectedEtiquetasObject(rowData);

    let newDataTodosPedidosSelectedEtiquetas = this.state.dataTodosPedidosSelectedEtiquetas;

    const index = newDataTodosPedidosSelectedEtiquetas
      .findIndex(item => JSON.stringify(item) === JSON.stringify(produto));

    if (index > -1) {
      return true;
    } else {
      return false;
    }
  }

  handleDataTodosPedidosSelectedEtiquetas = (rowData) => {
    const produto = this.shapeDataTodosPedidosSelectedEtiquetasObject(rowData);
    let newDataTodosPedidosSelectedEtiquetas = this.state.dataTodosPedidosSelectedEtiquetas;

    const index = newDataTodosPedidosSelectedEtiquetas
      .findIndex(item => JSON.stringify(item) === JSON.stringify(produto));

    if (index > -1) {
      newDataTodosPedidosSelectedEtiquetas.splice(index, 1);
    } else {
      newDataTodosPedidosSelectedEtiquetas.push(produto);
    }

    this.setState({
      dataTodosPedidosSelectedEtiquetas: newDataTodosPedidosSelectedEtiquetas,
    });
  }

  // { nr_pc, id_prod, cd_fil, dt_entrg }
  // esses quatro atributos formam uma chave composta no banco,
  // é a única forma de termos um identificador único para cada produto
  // E o nm_prod é pra mostrar no Modal de Download das etiquetas
  shapeDataTodosPedidosSelectedEtiquetasObject = (rowData) => {
    return {
      nr_pc: rowData[1],
      id_prod: rowData[3],
      nm_prod: rowData[5],
      cd_fil: rowData[27],
      dt_entrg: rowData[8],
    };
  }

  getNomeProdutosSelectedEtiquetas = () => {
    const data = this.state.dataTodosPedidosSelectedEtiquetas
      .map((item) => {
        return {
          id: item.id_prod,
          nome: item.nm_prod,
        }
      });

    const unique_prods = data.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === data.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      })
    });
    return unique_prods;
  }

  render() {
    return (
      <>
        <Helmet>
          <title>{`${process.env.REACT_APP_TITLE} - ${this.state.title}`}</title>
        </Helmet>
        <Cabecario title={this.state.title} />
        <br />
        <Can permissions={["filtro-fornecedor"]}>
          <Filter {...this} />
        </Can>
        <br />
        <Can
          some permissions={[
            "gerenciar-pedidos.todos-pedidos",
            "gerenciar-pedidos.pendentes",
            "gerenciar-pedidos.confirmados",
            "gerenciar-pedidos.recusados",
            "gerenciar-pedidos.protocolo-agendamento",
            "gerenciar-pedidos.entregas-concluidas",
            "gerenciar-pedidos.retiradas-pendentes"
          ]}
        >
          <Tabs {...this} />
        </Can>

        <Loader {...this} />
        <Alerta ref={this.childAlerta} />
        <Progress {...this} />
      </>
    );
  }

};

export default GerenciarPedidos;

